import CheckoutPage from ".";
const CheckoutPageRoutes = {
  routes: [
    {
      path: "/checkout",
      component: CheckoutPage,
      exact: true,
    },
  ],
};
export default CheckoutPageRoutes;
